export const CONFIRM_CART_DETAILS: string = "CONFIRM_CART_DETAILS";
export const RESET_CART_DETAILS: string = "RESET_CART_DETAILS";
export const DELETE_PAYMENT_INTENT: string = "DELETE_PAYMENT_INTENT";